import { isPC } from '../../utils/browser.js';

const state = {
  opened: sessionStorage.getItem('open')
    ? sessionStorage.getItem('b_open')
    : 'false', // 是否开启了左侧小菜单栏
  msgIsShow: false,
  isPC: isPC(), // 目前项目是运行在pc/移动端
}
const mutations = {
  SET_OPENED(state, payload) {
    state.opened = String(payload)
    sessionStorage.setItem('b_open', payload)
  },
  SET_MSGISOPEN(state) {
    state.msgIsShow = !state.msgIsShow
  }
}
export default {
  namespaced: true,
  state,
  mutations
}